import React from 'react';
import WaringGif from '../../images/warning-yellow.gif'
import "./Success&ErrorPopups.css"
import { Button, Modal, ModalBody } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import { warningModalToggle } from '../../redux/actions/Index';

function WarningPopupActive({ deleteData }) {
    const dispatch = useDispatch()
    const warningpopup = useSelector((state) => state?.ModalReducer?.warningToggle2);
    const deletableId = useSelector((state) => state?.ModalReducer?.deleteableId2);



    return (
        <div>

            <Modal isOpen={warningpopup} className="modal-style">
                <ModalBody className="py-3">
                    <div className="d-flex justify-content-center align-items-center flex-column gap-1">
                        <div className="cards-img mb-5">
                            <img src={WaringGif} alt="Success Gif" className="img-fit" />
                        </div>
                        <h1 className="title-font-bold fs-1 mb-2 text-uppercase text-base-yellow ">Warning !</h1>
                        <p className="text-base-yellow text-center mb-4 fs-6">
                            Your account has been deactived
                        </p>
                        <div className="d-flex justify-content-between align-items-center gap-4">
                            <Button className='rounded-pill px-5 py-3 popup-buttons-warning' onClick={() => deleteData(deletableId)} ><span className='fs-3 d-flex gap-3 title-font-400 '>Logout</span></Button>
                        </div>
                    </div>
                </ModalBody>
            </Modal>
        </div>
    );
}

export default WarningPopupActive;
